import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getCustomDomains, getCustomDomainsBySearch } from '../../services/customDomain';
import { CircularProgress } from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

const CustomDomains = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [customDomains, setCustomDomains] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayCustomDomains();
  }, [isSearching, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'channelId', 'domain', 'status', 'createdAt', 'updatedAt', 'deletedAt'];

  const customActions = [
    {
      icon: <Launch />,
      action: item => {
        history.push(`/ssl/${item.activeSSL}`);
      },
    },
  ];

  const displayCustomDomains = async () => {
    try {
      setIsLoading(true);
      let customDomainAux;
      if (isSearching) {
        const { data } = await getCustomDomainsBySearch(searchField.searchItem, searchField.search);
        customDomainAux = data;
      } else if (!isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getCustomDomains(page);
        customDomainAux = data;
      }
      if (!customDomainAux) return;

      setCustomDomains(customDomainAux.rows);
      setTotalItems(customDomainAux.count);
      setTotalPages(customDomainAux.pages);
      setPage(customDomainAux.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Custom Domains ({totalItems})</h1>

        <SearchBox selectItems={['id', 'channelId', 'cloudFrontId', 'domain', 'status']} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
      </div>

      <DataTable
        head={headers}
        body={customDomains}
        action={true}
        customActions={customActions}
        bodyColumn={headers}
        linkPath="custom-domains"
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default CustomDomains;
